module.exports = __webpack_public_path__ + "static/media/bg2_xs.f2347284.webp";